<template>
  <Container>
    <div class="ui segments raised">
      <CardTitle
          title="Eloca Store"
          iconClass="icon shopping bag"
          titleClass="ui blue large ribbon label"
          segmentStyle="display: flex"
        >
      </CardTitle>
      <ContainerBody>
        <div class="ui griddoubling stackable three column ui grid container">
          <div class="four wide column" v-for="(item, index) in lista" :key="index">
            <div class="fields">
              <div class="ui card" style="min-height: 300px;">
                <div class="ui fluid image" v-if="item.destaque">
                  <a class="ui red right corner label">
                    <i class="star icon"></i>
                  </a>
                </div>
                <div class="content">
                  <div class="header" style="margin-bottom: 20px; text-align: center;">
                    <div v-if="item.icone">
                      <i :class="item.icone" style="font-size: 4em; margin-top: 40px;"></i>
                    </div>
                    <span style="color: royalblue;">{{ item.nome }}</span>

                  </div>
                  <div class="description">
                    <div v-html="item.descricao"></div>
                  </div>
                  <div class="ui segment secondary" v-if="item.valor">
                    <div class="value">
                      <div v-html="item.valor"></div>
                    </div>
                  </div>
                </div>
                <div class="extra content">
                  <div class="ui two buttons">
                    <button class="ui basic green button pd-4" @click="registraInteresse(item.recnum)" v-if="!item.autocontrato"><i class="icon envelope"></i>Tenho interesse</button>
                    <button class="ui basic blue button pd-4" @click="contrata(item.recnum)" v-if="item.autocontrato && !item.contrato"><i class="icon cart"></i>Contratar</button>
                    <button class="ui basic red button pd-4" @click="cancela(item.recnum, item.contrato)" v-if="item.autocontrato && item.contrato"><i class="icon remove"></i>Cancelar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ten wide column" v-if="lista.length == 0">
            Não existem serviços disponíveis
          </div>
        </div>
      </ContainerBody>
    </div>
  </Container>
</template>

<script>
import CardTitle from '@/components/CardTitle.vue';
import Container from '@/components/Container.vue';
import ContainerBody from '@/components/ContainerBody.vue';

import api from '@/services/api';
import moment from 'moment';

export default {
  name: 'Whatsapp',
  components: {
    CardTitle,
    Container,
    ContainerBody,
  },
  data() {
    return {
      lista: [],
      recno: null,
      tipoUsr: sessionStorage.getItem('@ERP:tipo'),

      form: {
        nome: null,
        descricao: null,
      },
    };
  },
  async mounted() {
    this.loadServicos();
  },
  created() {

  },
  methods: {
    async loadServicos() {
      this.$store.commit('global/loading');
      await api.get('api/eloca/store')
        .then((result) => {
          this.lista = [];
          if (result.data.Entity.length > 0) {
            this.lista = result.data.Entity;
            const dataBase = moment().subtract(60, 'days');
            this.lista.forEach(item => {
              item.novo = moment(item.created_at).isAfter(dataBase);
            });
          }
        });
      this.$store.commit('global/loaded');
    },
    registraInteresse(recnum) {
      this.$store.commit('global/loading');
      api.get(`api/eloca/store/${recnum}/interesse`)
        .then(() => {
          this.$alertify.success('Interesse no serviço registrado com sucesso');
        }).catch(() => {
          this.$alertify.error('Ocorreu um erro ao registrar o interesse');
        });
      this.$store.commit('global/loaded');
    },
    async contrata(recnum) {
      this.$store.commit('global/loading');
      await api.post(`api/eloca/store/${recnum}/contrata`)
        .then(() => {
          this.$alertify.success('Serviço contratado com sucesso');
        }).catch(() => {
          this.$alertify.error('Somente usuário Master ou Gerente Geral pode contratar serviços.');
        });
      await this.loadServicos();
      this.$store.commit('global/loaded');
    },
    async cancela(recnum, contrato) {
      this.$store.commit('global/loading');
      await api.delete(`api/eloca/store/${recnum}/cancela/${contrato}`)
        .then(() => {
          this.$alertify.success('Serviço cancelado com sucesso');
        }).catch(() => {
          this.$alertify.error('Somente usuário Master ou Gerente Geral pode cancelar serviços.');
        });
      await this.loadServicos();
      this.$store.commit('global/loaded');
    },
  },
};
</script>

<style scoped>
div.description span {
  font-weight: bold;
}
div.description {
  margin-top: 4px;
}
.pd-4 {
  padding: 4px;
  padding-top: 12px;
  padding-bottom: 12px;
}
.labelNew {
  margin-left: auto !important;
  position: absolute;
  right: 0px;
  top: 0px;
  font-size: 10px;
  color: white;
  background-color: #2185d0 !important;
  padding: 8px;
  border-radius: .28571429rem;
  border-radius: 0.285714rem;
  line-height: 1;
}
.card:hover {
  transform: scale(1.1);
}
</style>
